jQuery(document).ready(function (e) {  
  
$ = jQuery;
  
    //  $(document).ready(function() {
    //     $('.moderate.template-product label.variant__button-label:contains("Pack Of 1")').trigger('click');
    //  });

      $(document).ready(function() {
          $('.comprehensivegenetictest_benefits h2').click(function() {
            $(this).toggleClass('active');
            $(this).next('ul').slideToggle();
          });
      });

      $(document).on('click', '.carbcheck_close', function() {
          $('.carbcheck_overlay').hide();
      });

      $(".revealyourcarb_sec .question").each(function() {
          $(this).find("label span input").click(function() {
              if (!$(this).parents("label").hasClass("active")) {
                  $(this).closest(".question").find("label").removeClass("active");
                  $(this).parents("label").addClass("active");
              }
          });
      });

      $(document).ready(function() {  
        if ($(window).width() < 600) {
            $(window).scroll((function() {
                  $(window).scrollTop() + $(window).height() >= $(".cod_img_wp").offset().top - 2 ? $(".product-form__buttons").addClass("active") : $(".product-form__buttons").removeClass("active")
              }
            ));
        }  
      }); 

      

      // $(document).on("click", ".moderate-combo .shopify-payment-button", function() {
      //    console.log('.product-form__buttons .product-form__submit');
      //    $(".product-form__buttons .product-form__submit").trigger('click');
      // });

      //  $(document).on("click", ".moderate .shopify-payment-button", function() {
      //    $(".product-form__buttons .product-form__submit").trigger('click');
      //  });

      //  $(document).on("click", ".happy-gut .shopify-payment-button", function() {
      //    $(".product-form__buttons .product-form__submit").trigger('click');
      //  });

      $(document).ready(function() {
          function addAnchorToIcons(){
          var $icons = document.querySelectorAll(`.list-social__item a`);
            if (!$icons){
              return;
            }
            for (var each of $icons){
              each.setAttribute("target", "_blank");
            }
          }
          addAnchorToIcons();
      });  
  
      $(document).ready(function() {
         $('.custom_grids').masonry({
              itemSelector: 'li',
              percentPosition: true,
              stagger: 30,
              transitionDuration: '0.5s'
          });
      });  

      $(document).ready(function() {
            // Define the data for each option
            var chicken_biryani_data = [
                ['<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/chicken_biryani.png" alt="" style="width:24px;" /> 1Bowl (289g)', 'Calories(cal)<sup>*</sup>', 'Carbs(g)<sup>*</sup>', 'Protein(g)<sup>*</sup>'],
                ['<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/without_moderate.png" alt="" style="width:18px;" /> Without<br/> Moderate', '389', '41.3', '18.6'], 
                ['<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/with_moderate.png" alt="" style="width:18px;" /> With<br/> Moderate', '322.9<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/green_uparrow.png?v=1695895486" alt="" style="width:15px;" />', '24.8<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/green_uparrow.png?v=1695895486" alt="" style="width:15px;" />', '18.6']
            ];
            var masala_dosa_data = [
                ['<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/masala_dosa.png" alt="" style="width:24px;" /> 2 Dosa (272g)', 'Calories(cal)<sup>*</sup>', 'Carbs(g)<sup>*</sup>', 'Protein(g)<sup>*</sup>'],
                ['<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/without_moderate.png" alt="" style="width:18px;" /> Without<br/> Moderate', '416', '56.2', '10'], 
                ['<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/with_moderate.png" alt="" style="width:18px;" /> With<br/> Moderate', '326<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/green_uparrow.png?v=1695895486" alt="" style="width:15px;" />', '33.7<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/green_uparrow.png?v=1695895486" alt="" style="width:15px;" />', '10']
            ];
            var chicken_fried_rice_data = [
                ['<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/chicken_fried_rice.png" alt="" style="width:24px;" /> Chicken Fried Rice(289g)', 'Calories(cal)<sup>*</sup>', 'Carbs(g)<sup>*</sup>', 'Protein(g)<sup>*</sup>'],
                ['<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/without_moderate.png" alt="" style="width:18px;" /> Without<br/> Moderate', '359', '33.7', '25.5'], 
                ['<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/with_moderate.png" alt="" style="width:18px;" /> With<br/> Moderate', '305.2<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/green_uparrow.png?v=1695895486" alt="" style="width:15px;" />', '20.2<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/green_uparrow.png?v=1695895486" alt="" style="width:15px;" />', '25.5']
            ];
            var paneer_butter_masala_data = [
                ['<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/paneer_butter_masala.png" alt="" style="width:24px;" /> Paneer Butter Masala(350g)', 'Calories(cal)<sup>*</sup>', 'Carbs(g)<sup>*</sup>', 'Protein(g)<sup>*</sup>'],
                ['<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/without_moderate.png" alt="" style="width:18px;" /> Without<br/> Moderate', '522', '14.8', '19.8'], 
                ['<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/with_moderate.png" alt="" style="width:18px;" /> With<br/> Moderate', '498.3<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/green_uparrow.png?v=1695895486" alt="" style="width:15px;" />', '8.9<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/green_uparrow.png?v=1695895486" alt="" style="width:15px;" />', '19.8']
            ];
            var veg_fried_rice_data = [
                ['<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/veg_fried_rice.png" alt="" style="width:24px;" /> Veg Fried Rice(289g)', 'Calories(cal)<sup>*</sup>', 'Carbs(g)<sup>*</sup>', 'Protein(g)<sup>*</sup>'],
                ['<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/without_moderate.png" alt="" style="width:18px;" /> Without<br/> Moderate', '317', '51.9', '5.5'], 
                ['<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/with_moderate.png" alt="" style="width:18px;" /> With<br/> Moderate', '234<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/green_uparrow.png?v=1695895486" alt="" style="width:15px;" />', '31.1<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/green_uparrow.png?v=1695895486" alt="" style="width:15px;" />', '5.5']
            ];
            var veg_biryani_data = [
                ['<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/veg_biryani.png" alt="" style="width:24px;" /> Veg Biryani(289g)', 'Calories(cal)<sup>*</sup>', 'Carbs(g)<sup>*</sup>', 'Protein(g)<sup>*</sup>'],
                ['<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/without_moderate.png" alt="" style="width:18px;" /> Without<br/> Moderate', '334', '47.4', '5.8'], 
                ['<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/with_moderate.png" alt="" style="width:18px;" /> With<br/> Moderate', '258.2<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/green_uparrow.png?v=1695895486" alt="" style="width:15px;" />', '28.4<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/green_uparrow.png?v=1695895486" alt="" style="width:15px;" />', '5.8']
            ];
            var butter_naan_data = [
                ['<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/butter_naan.png" alt="" style="width:24px;" /> 2 Butter Naan(184g)', 'Calories(cal)<sup>*</sup>', 'Carbs(g)<sup>*</sup>', 'Protein(g)<sup>*</sup>'],
                ['<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/without_moderate.png" alt="" style="width:18px;" /> Without<br/> Moderate', '536', '67.2', '11.1'], 
                ['<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/with_moderate.png" alt="" style="width:18px;" /> With<br/> Moderate', '428.5<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/green_uparrow.png?v=1695895486" alt="" style="width:15px;" />', '40.3<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/green_uparrow.png?v=1695895486" alt="" style="width:15px;" />', '11.1']
            ];
            var gulab_jamun_data = [
                ['<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/jamun_gulab_icon_cfb745b2-391c-4cc5-8606-d0d07a31f840.png" alt="" style="width:24px;" /> 3 Jamun(135g)', 'Calories(cal)<sup>*</sup>', 'Carbs(g)<sup>*</sup>', 'Sugars(g)<sup>*</sup>'],
                ['<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/without_moderate.png" alt="" style="width:18px;" /> Without<br/> Moderate', '450', '71.8', '48.6'], 
                ['<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/with_moderate.png" alt="" style="width:18px;" /> With<br/> Moderate', '335.1<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/green_uparrow.png?v=1695895486" alt="" style="width:15px;" />', '43.1<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/green_uparrow.png?v=1695895486" alt="" style="width:15px;" />', '29.1']
            ];
            var rasmalai_data = [
                ['<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/rasmalai.png" alt="" style="width:24px;" /> 2 Rasmalai(150g)', 'Calories(cal)<sup>*</sup>', 'Carbs(g)<sup>*</sup>', 'Protein(g)<sup>*</sup>'],
                ['<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/without_moderate.png" alt="" style="width:18px;" /> Without<br/> Moderate', '321.0', '27.5', '14.6'], 
                ['<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/with_moderate.png" alt="" style="width:18px;" /> With<br/> Moderate', '277<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/green_uparrow.png?v=1695895486" alt="" style="width:15px;" />', '16.5<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/green_uparrow.png?v=1695895486" alt="" style="width:15px;" />', '14.6']
            ];
            var aloo_paratha_data = [
                ['<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/aloo_paratha.png" alt="" style="width:24px;" /> 2 Paratha(200g)', 'Calories(cal)<sup>*</sup>', 'Carbs(g)<sup>*</sup>', 'Protein(g)<sup>*</sup>'],
                ['<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/without_moderate.png" alt="" style="width:18px;" /> Without<br/> Moderate', '406.0', '62.4', '9.4'], 
                ['<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/with_moderate.png" alt="" style="width:18px;" /> With<br/> Moderate', '306.2<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/green_uparrow.png?v=1695895486" alt="" style="width:15px;" />', '37.4<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/green_uparrow.png?v=1695895486" alt="" style="width:15px;" />', '9.4']
            ];
            var samosa_data = [
                ['<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/samosa.png" alt="" style="width:24px;" /> 2 Samosa(200g)', 'Calories(cal)<sup>*</sup>', 'Carbs(g)<sup>*</sup>', 'Protein(g)<sup>*</sup>'],
                ['<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/without_moderate.png" alt="" style="width:18px;" /> Without<br/> Moderate', '552', '55.8', '7.1'], 
                ['<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/with_moderate.png" alt="" style="width:18px;" /> With<br/> Moderate', '462.7<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/green_uparrow.png?v=1695895486" alt="" style="width:15px;" />', '33.5<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/green_uparrow.png?v=1695895486" alt="" style="width:15px;" />', '7.1']
            ];
            var pav_bhaji_data = [
                ['<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/pav_bhaji.png" alt="" style="width:24px;" /> 1 Plate(240g)', 'Calories(cal)<sup>*</sup>', 'Carbs(g)<sup>*</sup>', 'Protein(g)<sup>*</sup>'],
                ['<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/without_moderate.png" alt="" style="width:18px;" /> Without<br/> Moderate', '382.0', '61.3', '8.3'], 
                ['<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/with_moderate.png" alt="" style="width:18px;" /> With<br/> Moderate', '283.9<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/green_uparrow.png?v=1695895486" alt="" style="width:15px;" />', '36.8<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/green_uparrow.png?v=1695895486" alt="" style="width:15px;" />', '8.3']
            ];
            var french_fries_data = [
                ['<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/french_fries.png" alt="" style="width:24px;" /> 1 Cup(112g)', 'Calories(cal)<sup>*</sup>', 'Carbs(g)<sup>*</sup>', 'Protein(g)<sup>*</sup>'],
                ['<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/without_moderate.png" alt="" style="width:18px;" /> Without<br/> Moderate', '352.0', '43.1', '4.2'], 
                ['<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/with_moderate.png" alt="" style="width:18px;" /> With<br/> Moderate', '283<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/green_uparrow.png?v=1695895486" alt="" style="width:15px;" />', '25.9<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/green_uparrow.png?v=1695895486" alt="" style="width:15px;" />', '4.2']
            ];
            var chicken_65_data = [
                ['<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/chicken_65.png" alt="" style="width:24px;" /> 1 Cup(166g)', 'Calories(cal)<sup>*</sup>', 'Carbs(g)<sup>*</sup>', 'Protein(g)<sup>*</sup>'],
                ['<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/without_moderate.png" alt="" style="width:18px;" /> Without<br/> Moderate', '407.0', '12.7', '23.6'], 
                ['<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/with_moderate.png" alt="" style="width:18px;" /> With<br/> Moderate', '386.7<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/green_uparrow.png?v=1695895486" alt="" style="width:15px;" />', '7.6<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/green_uparrow.png?v=1695895486" alt="" style="width:15px;" />', '23.6']
            ];
            var chilli_chicken_data = [
                ['<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/chili_chicken.png" alt="" style="width:24px;" /> 1 Cup(166g)', 'Calories(cal)<sup>*</sup>', 'Carbs(g)<sup>*</sup>', 'Protein(g)<sup>*</sup>'],
                ['<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/without_moderate.png" alt="" style="width:18px;" /> Without<br/> Moderate', '294.0', '13.9', '20.4'], 
                ['<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/with_moderate.png" alt="" style="width:18px;" /> With<br/> Moderate', '271.8<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/green_uparrow.png?v=1695895486" alt="" style="width:15px;" />', '8.3<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/green_uparrow.png?v=1695895486" alt="" style="width:15px;" />', '20.4']
            ];
            var chicken_shawarma_data = [
                ['<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/chicken_shawarma.png" alt="" style="width:24px;" /> 1 Roll(225g)', 'Calories(cal)<sup>*</sup>', 'Carbs(g)<sup>*</sup>', 'Protein(g)<sup>*</sup>'],
                ['<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/without_moderate.png" alt="" style="width:18px;" /> Without<br/> Moderate', '391.0', '27.7', '24.7'], 
                ['<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/with_moderate.png" alt="" style="width:18px;" /> With<br/> Moderate', '346.7<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/green_uparrow.png?v=1695895486" alt="" style="width:15px;" />', '16.6<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/green_uparrow.png?v=1695895486" alt="" style="width:15px;" />', '24.7']
            ];
            var chole_bhature_data = [
                ['<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/chole_bhature.png" alt="" style="width:24px;" /> 1 Serve(250g)', 'Calories(cal)<sup>*</sup>', 'Carbs(g)<sup>*</sup>', 'Protein(g)<sup>*</sup>'],
                ['<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/without_moderate.png" alt="" style="width:18px;" /> Without<br/> Moderate', '445.0', '46.3', '8.9'], 
                ['<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/with_moderate.png" alt="" style="width:18px;" /> With<br/> Moderate', '370.9<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/green_uparrow.png?v=1695895486" alt="" style="width:15px;" />', '27.8<img src="https://cdn.shopify.com/s/files/1/0760/1527/2257/files/green_uparrow.png?v=1695895486" alt="" style="width:15px;" />', '8.9']
            ];
  
          // Function to update the table based on the selected option
            function updateTable(selectedValue) {
            var table = $('#dataTable');
            var data;
  
            // Determine which data to use based on the selected option
            if (selectedValue === 'chicken_biryani') {
               data = chicken_biryani_data;
            } else if (selectedValue === 'masala_dosa') {
               data = masala_dosa_data;
            } else if (selectedValue === 'chicken_fried_rice') {
               data = chicken_fried_rice_data;
            } else if (selectedValue === 'paneer_butter_masala') {
               data = paneer_butter_masala_data;
            } else if (selectedValue === 'veg_fried_rice') {
               data = veg_fried_rice_data;
            } else if (selectedValue === 'veg_biryani') {
               data = veg_biryani_data;
            } else if (selectedValue === 'butter_naan') {
               data = butter_naan_data;
            } else if (selectedValue === 'gulab_jamun') {
               data = gulab_jamun_data;
            } else if (selectedValue === 'rasmalai') {
               data = rasmalai_data;
            } else if (selectedValue === 'aloo_paratha') {
               data = aloo_paratha_data;
            } else if (selectedValue === 'samosa') {
               data = samosa_data;
            } else if (selectedValue === 'pav_bhaji') {
               data = pav_bhaji_data;
            } else if (selectedValue === 'french_fries') {
               data = french_fries_data;
            } else if (selectedValue === 'chicken_65') {
               data = chicken_65_data;
            } else if (selectedValue === 'chilli_chicken') {
               data = chilli_chicken_data;
            } else if (selectedValue === 'chicken_shawarma') {
               data = chicken_shawarma_data;
            } else if (selectedValue === 'chole_bhature') {
               data = chole_bhature_data;
            }  
  
            // Update the table with the selected data
            for (var i = 0; i < 5; i++) {
                 for (var j = 0; j < 4; j++) {
                    if (i === 1 || i === 2) {
                       // Check if it's the second or third row
                       if (j === 0) {
                          // This is the first th element in the row
                          table.find('tr:eq(' + i + ') th:eq(' + j + ')').html(data[i][j]);
                       } else {
                          // These are td elements in the row
                          table.find('tr:eq(' + i + ') td:eq(' + (j - 1) + ')').html(data[i][j]);
                       }
                    } else {
  
                         // These are th elements in the thead or td elements in other rows
                         table.find('tr:eq(' + i + ') td:eq(' + j + '), thead tr:eq(' + i + ') th:eq(' + j + ')').html(data[i][j]);
                      }
                 }
              }
          }
           
           // Listen for the "Apply" button click
			$('#applyButton').click(function() {
              //alert('ss');
				var selectedValue = $('#selUser').val();
				if (selectedValue.length !== 0) {
					$(".carbs_table").show();
					updateTable(selectedValue);
				} else {
					// Hide the table when no value is selected
					$(".carbs_table").hide();
				}
			});

      });
  
        $(window).scroll(function() {
          if ($(this).scrollTop() > $(document).height() * 0.2) {
            $('.scroll-button').fadeIn();
          } else {
            $('.scroll-button').fadeOut();
          }
        });
  
        // Smooth scroll to bottom
        $('.scroll-button').click(function(e) {
          e.preventDefault();
          $('html, body').animate({
            scrollTop: 0
          }, 1000);
        });

        $('.marquee-slider').slick({
            dots: false,
            infinite: true,
            speed: 100,
            autoplay: true,
            slidesToShow: 8,
            slidesToScroll: 2,
         	arrows: false,
            autoplaySpeed: 0,
            speed: 2000,
            pauseOnHover: true,
            cssEase: 'linear',
            responsive: [
              {
                breakpoint: 1024,
                settings: {
                  slidesToShow: 7,
                  slidesToScroll: 3,
                  infinite: true
                }
              },
              {
                breakpoint: 769,
                settings: {
                  slidesToShow: 4,
                  slidesToScroll: 2
                }
              },
              {
                breakpoint: 480,
                settings: {
                  slidesToShow: 2,
                  slidesToScroll: 1
                }
              }
            ]
        });

  $('.moderatetypes_slider').slick({
      dots: true,
      arrows : false,
      slidesToShow: 2,
      slidesToScroll: 1,
      autoplay: true, 
      autoplaySpeed: 2000, 
      infinite: true, 
      speed: 300,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 2, slidesToScroll: 1 } },
        { breakpoint: 980, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
      ],
  });

  $('#selUser').select2({
        sorter: data => data.sort((a, b) => a.text.localeCompare(b.text)),
        placeholder: {
            id: '', // the value of the option
            text: 'Pick Your Meal'
        },
        allowClear: true
  });

  $('.scientificexcellence_slider').slick({
      dots: true,
      arrows : false,
      autoplay: true, 
      autoplaySpeed: 2000,
      slidesToShow: 3,
      slidesToScroll: 1,
      responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 1 } },
        { breakpoint: 769, settings: { slidesToShow: 3, slidesToScroll: 1 } },
        { breakpoint: 480, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      ],
  });

    $('.bloodcollection_slider').slick({
        dots: true,
        infinite: true,
        autoplay: true, 
        autoplaySpeed: 10000,
        slidesToShow: 1,
        adaptiveHeight: true
    }); 
    $(".testimonialvideos_slider").slick({
        slidesToShow:4,
        slidesToScroll: 1,
        infinite : false,
        arrows: true,
        responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 4, slidesToScroll: 1, infinite: !0 } },
            { breakpoint: 769, settings: { slidesToShow: 3, slidesToScroll: 2 } },
            { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        ],
    });
    $(".clinicalstudies_slider").slick({
        slidesToShow: 2,
        slidesToScroll: 2,
        dots: true,
        responsive: [
            { breakpoint: 1024, settings: { slidesToShow: 2, slidesToScroll: 2, infinite: !0 } },
            { breakpoint: 769, settings: { slidesToShow: 2, slidesToScroll: 2 } },
            { breakpoint: 500, settings: { slidesToShow: 1, slidesToScroll: 1 } },
        ],
    });
    $(".favouritecarbssugars_slider").slick({
        slidesToShow: 1,
        slidesToScroll: 1,
        dots: true
    });

$('.testimoniapopup-modal').magnificPopup({
          type: 'inline',
          preloader: false,
          focus: '#name',
          closeBtnInside: false,
          closeOnContentClick: false,
          closeOnBgClick: true,
          enableEscapeKey: true,
          modal: true,
          asNavFor: ".mfp-arrow",
          gallery: {
            enabled: true,
            tPrev: '@T("Media.MagnificPopup.Previous")',
            tNext: '@T("Media.MagnificPopup.Next")',
          },
          callbacks: {
            open: function () {
          
              var $videos = $('.white-popup-block video');
              if ($videos.length > 0) {
                $videos.each(function () {
                  this.pause();
                  this.currentTime = 0;
                });
              }
            var $video = $('.mfp-content video');
              if ($video.length > 0) {
                $video.each(function () {
                  this.pause();
                  this.currentTime = 0;
                });
                $video.first().get(0).play();
              }
            },
            change: function () {
              console.log('newchange');
              var $videos = $('.white-popup-block video');
              if ($videos.length > 0) {
                $videos.each(function () {
                  this.pause();
                  this.currentTime = 0;
                });
              }
          
              setTimeout(function(){
                
                var $video = $('.mfp-content video');
                if ($video.length > 0) {
                  console.log('innn')
                  $video.first().get(0).play();
                }
              
              }, 200);
            },
            close: function () {
              var $video = $('.white-popup-block video');
              if ($video.length > 0) {
                $video.each(function () {
                  this.pause();
                  this.currentTime = 0;
                });
              }
            }
          }
      }),
      

      $('.fifth_title b').each(function () {
          $(this).prop('Counter',0).animate({
              Counter: $(this).text()
          }, {
              duration: 4000,
              easing: 'swing',
              step: function (now) {
                  $(this).text(Math.ceil(now));
              }
          });
      }); 
  
      $(window).load(function(){
          $('.custom_grids').masonry({
              itemSelector: 'li'
          });
      });   
      $(document).ready(function() {
        if ($('.testimonial-slider').length && !$('.testimonial-slider').hasClass('noslider')) {

          $('.testimonial-slider').slick({
              dots: false,
              infinite: true,
              speed: 300,
              slidesToShow: 3,
              arrows : true,
              adaptiveHeight: true,
              responsive: [
                {
                  breakpoint:1500,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                  }
                },
                {
                  breakpoint: 1024,
                  settings: {
                      slidesToShow: 2,
                      slidesToScroll: 1,
                  }
                },
                {
                  breakpoint:600,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                  }
                }
              ]
          });
          }

        if ($('.ingredients-slider').length && !$('.ingredients-slider').hasClass('noslider')) {

          $('.ingredients-slider').slick({
              dots: false,
              infinite: true,
              speed: 300,
              slidesToShow: 3,
              arrows : true,
              adaptiveHeight: true,
              responsive: [
                {
                  breakpoint:1500,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                  }
                },
                {
                  breakpoint: 1024,
                  settings: {
                      slidesToShow: 2,
                      slidesToScroll: 1,
                  }
                },
                {
                  breakpoint:600,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: false,
                  }
                }
              ]
          });
          }

        $('.product-variations-slider').slick({
              dots: false,
              infinite: true,
              speed: 300,
              slidesToShow: 3,
              arrows : false,
              adaptiveHeight: true,
              //centerMode: true,
              //centerPadding: '2%',
              responsive: [
                {
                  breakpoint:1500,
                  settings: {
                    slidesToShow: 3,
                    slidesToScroll: 1,
                  }
                },
                {
                  breakpoint: 1024,
                  settings: {
                      slidesToShow: 2,
                      slidesToScroll: 1,
                  }
                },
                {
                  breakpoint:600,
                  settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                  }
                }
              ]
          });
   
           $('.prdtpage-var-slider').slick({
                dots: false,
                infinite: true,
                speed: 300,
                slidesToShow:1,
                arrows : false,
                adaptiveHeight: true,
                centerMode: true,
                centerPadding: '2%',
            });
        
            
        
            $('.team_nav').slick({
                dots: false,
                infinite: true,
                speed: 300,
                slidesToShow:4,
                arrows : true,
                adaptiveHeight: true,
                responsive: [
                  {
                    breakpoint: 1024,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 1,
                    }
                  },
                  {
                    breakpoint:600,
                    settings: {
                      slidesToShow: 1,
                      slidesToScroll: 1,
                    }
                  }
                ]
            });

            $('.popup-modal').magnificPopup({
                type: 'inline',
                preloader: false,
                focus: '#name',
                closeBtnInside: false,
                closeOnContentClick: false,
                closeOnBgClick: true,
                enableEscapeKey: true,
                modal: true,
                asNavFor: ".mfp-arrow",
                gallery: {
                    enabled: true,
                    tPrev: '@T("Media.MagnificPopup.Previous")',
                    tNext: '@T("Media.MagnificPopup.Next")',
                }
            });

            $('.scientific-popup-modal').magnificPopup({
                type: 'inline',
                preloader: false,
                focus: '#username',
                modal: true
            });
        
       });

    	$(document).on('click', '.popup-modal-dismiss', function (e) {
    		e.preventDefault();
    		$.magnificPopup.close();
    	});

    $('.readmore .readmore_cont').expander({
        slicePoint:190,
        expandEffect: 'slideDown',
        collapseEffect: 'slideUp'
    });
  
    $('.testimonial-slider .textexpand:not(.noslider .textexpand)').expander({
       slicePoint:260
    });    

    $('div#ImageWithText--template--19210782671169__f8fae02d-5267-4a4c-ba29-ff473f597ab2 a').attr('target',"_blank");

    wow = new WOW({
        boxClass: 'wow', // default
        animateClass: 'animated', // default
        offset: 0, // default
        mobile: false, // default
        live: true // default
    })
    wow.init();

    $(document).ready(function() {
      if ($('.fifth-custom-section').length > 0) {
      var eventFired = false,
        objectPositionTop = $('.fifth-custom-section').offset().top;
            $(window).on('scroll', function() {
              var currentPosition = $(document).scrollTop();
              if (currentPosition > objectPositionTop && eventFired === false) {
                eventFired = true;

                $(".number_hide").hide();
                
                // your code
                  animateCounter('.counter-1');
                  animateCounter('.counter-2');
                  animateCounter('.counter-3');
              }
            });
        }
    });

  function animateCounter(counterClass) {
    var initialText = $(counterClass).text(); // Store the initial value
    var targetValue = parseInt(initialText, 10);
  
    $({ Counter: 0 }).animate({
      Counter: targetValue
    }, {
      duration: 5000,
      easing: 'swing',
      step: function() {
        var animatedValue = Math.ceil(this.Counter) + "%";
        $(counterClass).text(animatedValue);
      },
      complete: function() {
        // Reset the counter back to its initial value once animation completes
        $(counterClass).text(initialText);
      }
    });
  }



});       